var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoOriginal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 325",
    style: {
      enableBackground: "new 0 0 500 325"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2D383F;}\n\t.st1{fill:#6DBF5D;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.3,163.7V51.5C9.3,24.2,27.5,5.1,54,5.1c26.2,0,44.7,19.1,44.7,46.4V60H70.8v-9.4c0-14.2-8.3-18.8-16.8-18.8 c-8.8,0-17.1,4.6-17.1,18.8v113.9c0,14.2,8.3,18.5,17.1,18.5c8.8,0,16.8-4.3,16.8-18.5v-10.5h27.9v9.7c0,27.1-18.5,46.1-44.7,46.1 C27.5,209.9,9.3,190.8,9.3,163.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.5,135.3L104.7,7.1h28.5l22.2,83.8l22.5-83.8h28.5l-37.3,128.2v72.6h-27.6V135.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216.4,163.7V51.5c0-27.3,18.2-46.4,44.7-46.4c26.2,0,44.7,19.1,44.7,46.4V60h-27.9v-9.4 c0-14.2-8.3-18.8-16.8-18.8c-8.8,0-17.1,4.6-17.1,18.8v113.9c0,14.2,8.3,18.5,17.1,18.5c8.8,0,16.8-4.3,16.8-18.5v-10.5h27.9v9.7 c0,27.1-18.5,46.1-44.7,46.1C234.6,209.9,216.4,190.8,216.4,163.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.4,7.1h27.9v174.1H397v26.8h-70.6V7.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.3,301.5h10.9c0,5.9,3.6,7.7,7.2,7.7s6.7-2.3,6.7-6.4c0-3-0.8-5.3-3.9-10l-14.2-21c-5.3-7.8-6-12.3-6-16.9 c0-9.9,7.3-16.1,17.3-16.1c9.8,0,17.1,6.8,17.1,17.8H33.6c0-5.5-3.4-7.4-6.5-7.4c-3.3,0-6.1,2-6.1,5.9c0,2.7,0.9,5.8,3.5,9.5 l14.2,20.9c5.2,7.7,6.3,12.2,6.3,17.8c0,10.2-7.2,16.8-17.7,16.8S9.3,312.9,9.3,301.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.7,301.5v-44.3c0-10.8,7.2-18.4,17.7-18.4c10.4,0,17.7,7.6,17.7,18.4v44.3c0,10.7-7.3,18.3-17.7,18.3 C74.9,319.8,67.7,312.3,67.7,301.5z M85.4,309.2c3.4,0,6.7-1.8,6.7-7.3v-45.1c0-5.5-3.2-7.3-6.7-7.3c-3.6,0-6.8,1.8-6.8,7.3v45.1 C78.7,307.4,81.9,309.2,85.4,309.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130,239.5h11.1v68.9H158V319h-28V239.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.2,301.5v-62.1h10.9V302c0,5.8,3.6,7.2,6.8,7.2c3.3,0,6.7-1.7,6.7-7.2v-62.5h10.9v62.1 c0,10.7-7.3,18.3-17.6,18.3C188.5,319.8,181.2,312.3,181.2,301.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250.2,250.1h-10.5v-10.6h32.2v10.6h-10.6V319h-11.1V250.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.6,239.5h10.9V319h-10.9V239.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.6,301.5v-44.3c0-10.8,7.2-18.4,17.7-18.4c10.4,0,17.7,7.6,17.7,18.4v44.3c0,10.7-7.3,18.3-17.7,18.3 C340.8,319.8,333.6,312.3,333.6,301.5z M351.3,309.2c3.4,0,6.7-1.8,6.7-7.3v-45.1c0-5.5-3.2-7.3-6.7-7.3c-3.6,0-6.8,1.8-6.8,7.3 v45.1C344.5,307.4,347.8,309.2,351.3,309.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396,239.5h10.3l14.2,47.8v-47.8h11.1V319h-10.4l-14.2-46.8V319H396V239.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M455,301.5h10.9c0,5.9,3.6,7.7,7.2,7.7c3.6,0,6.7-2.3,6.7-6.4c0-3-0.8-5.3-3.9-10l-14.2-21 c-5.3-7.8-6-12.3-6-16.9c0-9.9,7.3-16.1,17.3-16.1c9.8,0,17.1,6.8,17.1,17.8h-10.7c0-5.5-3.4-7.4-6.5-7.4c-3.3,0-6.1,2-6.1,5.9 c0,2.7,0.9,5.8,3.5,9.5l14.2,20.9c5.2,7.7,6.3,12.2,6.3,17.8c0,10.2-7.2,16.8-17.7,16.8C462.5,319.9,455,312.9,455,301.5z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "460.2,62.8 460.2,5.1 446.3,5.1 446.3,62.8 415.8,62.8 415.8,76.2 490.7,76.2 490.7,62.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "490.7,120.1 490.7,93.3 415.8,93.3 415.8,207.9 490.7,207.9 490.7,181.1 439.3,181.1 439.3,164  490.7,164 490.7,137.2 439.3,137.2 439.3,120.1  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOriginal);
export default __webpack_public_path__ + "static/media/logo_original.a949825e206041cd6e64d0f875ce8e7c.svg";
export { ForwardRef as ReactComponent };